import { useEffect, useRef, useState } from 'react';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';
import { AnimationMixer } from 'three';
import { useFrame } from '@react-three/fiber';

const ModelAsset = ({ number, animation }) => {
  const [gltf, setGLTF] = useState(null);
  const mixerRef = useRef(null);

  useEffect(() => {
    const fetchYolo = async () => {
      try {
        // console.log("fetching yolo gltf...")
        const response = await fetch(`https://dc.yolokidz.io/api/gltf/${number}`);
        const data = await response.arrayBuffer();
        const blob = new Blob([data], { type: 'application/octet-stream' });
        const url = URL.createObjectURL(blob);

        const loader = new GLTFLoader();
        loader.load(url, (data) => {
          mixerRef.current = new AnimationMixer(data.scene);
          if (data.animations.length > 0) {
            const action = mixerRef.current.clipAction(data.animations[animation]);
            action.play();
          }
          setGLTF(data);
        });
      } catch (error) {
        console.error('Error fetching YOLO data:', error);
      }
    };

    fetchYolo();
  }, [number, animation]);

  // Update the mixer on each frame
  useFrame((state, delta) => mixerRef.current?.update(delta));

  useEffect(() => {
    if (gltf) {
      gltf.scene.traverse((object) => {
        if (object.isMesh) {
          object.castShadow = true;
          object.receiveShadow = true;
        }
      });
    }
  }, [gltf]);

  return (
    gltf && 
    <primitive
      object={gltf.scene}
      scale={0.04}
      position={[0, -1, 0]}
      rotation={[0, 3.5, 0]}
    />
  );
};

export default ModelAsset;
